import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Tree,
    Avatar,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { CloseOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
    ToolOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MinusSquareOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    PlusSquareOutlined,
    CheckCircleOutlined,
    UserOutlined,
    CheckOutlined
} from '@ant-design/icons'
import moment from 'moment';

const { Option, OptGroup } = Select;
const { Search } = Input;

class Qxedit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id, mkqx: [],

            }, //type2 横  type 纵
            qxlist: [],

            visible: false, loading: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        fetch('/User/doview', {
            method: "POST", body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    if (this.state.condition.id == store.getState().data.info.id) {
                        this.props.setinfo(data.data)
                    }
                    message.success(data.msg)
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/User/view', {
                method: "POST", body: JSON.stringify({
                    id: this.state.condition.id
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.status == 0) {
                        message.error(data.msg)
                        return
                    }
                    if (this.state.condition.id) {
                        that.setState({
                            condition: data.data,
                        })
                    }
                    that.setState({
                        qxlist: data.qxlist ? data.qxlist : [],
                        status_react: data.status_react ? data.status_react : [],
                        glyq_react: data.glyq_react ? data.glyq_react : [],
                        bumen_id_react: data.bumen_id_react ? data.bumen_id_react : [],
                        project_resource_permission_id_react: data.project_resource_permission_id_react ? data.project_resource_permission_id_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id, mkqx: [],
                }, //type2 横  type 纵
                qxlist: [],

                loading: false
            })
        }
    }


    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, { [name]: dateString })
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={Number(item.id)} key={index}>{item.name}</Option>)
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) => <Radio value={item.id} key={index}>{item.name}</Radio>)
        }
    }

    arrcheck(arr, num) {
        if (arr) {
            return arr.map((item, index) => (item.type2 == num) ?
                <td>{(item.id) ? <Checkbox value={item.id} key={index}></Checkbox> : null}</td> : null)
        }
    }

    arrcheck2(arr, num) {
        if (arr) {
            return arr.map((item, index) => <Checkbox value={item.id} key={index}>{item.name}</Checkbox>)
        }
    }

    allcheckMkqx(type = 0, type2 = 0, e) {
        var qxlist = this.state.qxlist.concat()
        var mkqx = this.state.condition.mkqx.concat()
        var name1 = 'qxlist'
        var name2 = 'mkqx'
        var qxlistnum = 0
        for (const key in qxlist) {
            const item = qxlist[key];
            if (item.id != 0) {
                qxlistnum++
            }
        }
        var arr = []
        if (type) {
            var hang = true //默认全选中
            for (const key in qxlist) {
                const item = qxlist[key];
                if (item.type == type && item.id != 0) {
                    arr = arr.concat(item.id)//本列所有选项的值
                }
            }
            // console.log('本行所有选项的值：' + arr);
            for (const key in arr) {
                const item = arr[key];
                if (!mkqx.includes(item)) {//有未选中的选项
                    hang = false
                    break
                }
            }
            // console.log('hang' + hang);
            if (!hang) {//有未选中的选项就全选
                mkqx = mkqx.concat(arr)
                mkqx = this.duplicateRemoval(mkqx);
                let data = Object.assign({}, this.state.condition, { [name2]: mkqx })
                this.setState({
                    condition: data
                })
            } else {//全选就取消全选
                arr.map((item, index) => {
                    for (const key in mkqx) {
                        const item2 = mkqx[key];
                        if (item2 == item) {
                            mkqx.splice(key, 1)
                        }
                    }
                })
                let data = Object.assign({}, this.state.condition, { [name2]: mkqx })
                this.setState({
                    condition: data
                })
            }
        }
        if (type2) {
            var hang = true //默认全选中
            for (const key in qxlist) {
                const item = qxlist[key];
                if (item.type2 == type2 && item.id != 0) {
                    arr = arr.concat(item.id)//本行所有选项的值
                }
            }
            // console.log('本行所有选项的值：' + arr);
            for (const key in arr) {
                const item = arr[key];
                if (!mkqx.includes(item)) {//有未选中的选项
                    hang = false
                    break
                }
            }
            // console.log('hang' + hang);
            if (!hang) {//有未选中的选项就全选
                mkqx = mkqx.concat(arr)
                mkqx = this.duplicateRemoval(mkqx);
                console.log('mkqx：' + mkqx);
                let data = Object.assign({}, this.state.condition, { [name2]: mkqx })
                this.setState({
                    condition: data
                })
            } else {//全选就取消全选
                arr.map((item, index) => {
                    for (const key in mkqx) {
                        const item2 = mkqx[key];
                        if (item2 == item) {
                            mkqx.splice(key, 1)
                        }
                    }
                })
                let data = Object.assign({}, this.state.condition, { [name2]: mkqx })
                this.setState({
                    condition: data
                })
            }
        }
        if (!type && !type2) {
            if (qxlistnum == mkqx.length && mkqx.length != 0) {
                let data = Object.assign({}, this.state.condition, { [name2]: [] })
                this.setState({
                    condition: data
                })
            } else {
                for (const key in qxlist) {
                    const item = qxlist[key];
                    if (item.id != 0) {
                        arr = arr.concat(item.id)
                    }
                }
                let data = Object.assign({}, this.state.condition, { [name2]: this.duplicateRemoval(arr) })
                this.setState({
                    condition: data
                })
            }
        }
    }

    duplicateRemoval(arr) {
        //定义接收去重后结果的新数组
        let newArr = [];
        for (let i = 0; i < arr.length; i++) {
            //判断新数组中是否存在当前索引为i的原数组元素
            if (!newArr.includes(arr[i])) {
                //如果不存在，则将其放到新数组的最后位置
                newArr.push(arr[i]);
            }
        }
        //返回去重后的新数组
        return newArr;
    }

    //栏目权限一级全选
    alllmqx = (pname, e) => {

        let that = this
        let arr = that.state.qxlist.concat()
        let mkqx = that.state.condition.mkqx.concat()
        // pname总数
        var total = 0
        //已选中个数
        var cknum = 0
        var arr_p = []
        arr.forEach(item => {
            if (item.pname == pname) {
                total++
                arr_p.push(item.id)
                if (mkqx.includes(item.id)) {
                    cknum++
                }
            }
        });
        console.log(total, cknum)
        if (total == cknum && cknum != 0) {
            for (const key in arr_p) {
                const item = arr_p[key];
                var index = mkqx.indexOf(item);
                if (index > -1) {
                    mkqx.splice(index, 1)
                }
            }
            let data = Object.assign({}, this.state.condition, { mkqx: this.duplicateRemoval(mkqx) })
            this.setState({
                condition: data
            })
        } else {
            for (const key in arr_p) {
                const item = arr_p[key];
                mkqx.push(item)
            }

            let data = Object.assign({}, this.state.condition, { mkqx: this.duplicateRemoval(mkqx) })
            this.setState({
                condition: data
            })
        }
    }

    render() {
        return (<>
            {this.props.id ? <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>{this.props.isbase ? <>
                <EditOutlined /> </> : null}编辑</a> : <>
                <Button type="primary" icon={<PlusOutlined />}
                    onClick={this.mdchange.bind(this)}>新增账号</Button>
            </>}

            <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={800}
                visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                <Form
                    layout="vertical"
                    // labelCol={{ span: 3 }}
                    wrapperCol={{ span: 24 }}
                    autoComplete="off"
                >
                    <Row gutter={[20, 0]} justify="start">
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="用户名"
                                required={true}
                            >
                                <Input placeholder="请输入"
                                    value={this.state.condition.username ? this.state.condition.username : null}
                                    onChange={this.onChange.bind(this, 'username')} />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="姓名"
                                required={true}
                            >
                                <Input placeholder="请输入"
                                    value={this.state.condition.name ? this.state.condition.name : null}
                                    onChange={this.onChange.bind(this, 'name')} />
                            </Form.Item>
                        </Col>
                        {this.props.isbase ? <></> : <>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="密码"
                                // required={true}
                                >
                                    <Input.Password placeholder="请输入"
                                        value={this.state.condition.password ? this.state.condition.password : null}
                                        onChange={this.onChange.bind(this, 'password')} />
                                </Form.Item>
                            </Col>
                        </>}
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="联系电话"
                                required={true}
                            >
                                <Input placeholder="请输入"
                                    value={this.state.condition.phone ? this.state.condition.phone : null}
                                    onChange={this.onChange.bind(this, 'phone')} />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="部门"
                                required={true}
                            >
                                <Select placeholder="请选择"
                                    style={{ width: "100%" }}
                                    value={this.state.condition.bumen_id ? this.state.condition.bumen_id : null}
                                    onChange={this.onSelChange.bind(this, 'bumen_id')} allowClear showSearch
                                    optionFilterProp="children">
                                    {this.arrsel(this.state.bumen_id_react)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label="项目查看权限"
                            >
                                <Select placeholder="请选择"
                                    style={{ width: "100%" }}
                                    value={this.state.condition.project_resource_permission_id ? this.state.condition.project_resource_permission_id : null}
                                    onChange={this.onSelChange.bind(this, 'project_resource_permission_id')} allowClear showSearch
                                    optionFilterProp="children">
                                    {this.arrsel(this.state.project_resource_permission_id_react)}
                                </Select>
                            </Form.Item>
                        </Col>
                        {this.props.isbase ? <></> : <>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="栏目权限"
                                >
                                    <Checkbox.Group style={{ width: '100%' }}
                                        value={this.state.condition.mkqx ? this.state.condition.mkqx : null}
                                        onChange={this.onSelChange.bind(this, 'mkqx')}>

                                        <table className='xmtable2'>
                                            <tr>
                                                <td>
                                                    {/*<a href='javascript:void(0)'
                                                       onClick={this.allcheckMkqx.bind(this, 0, 0)}
                                                       className="allcheck">全选</a>*/}
                                                </td>
                                                <td></td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 1, 0)}
                                                        className="allcheck">查看</a>
                                                    {/*查看*/}
                                                </td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 2, 0)}
                                                        className="allcheck">添加</a>
                                                    {/*添加*/}
                                                </td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 3, 0)}
                                                        className="allcheck">编辑</a>
                                                    {/*编辑*/}
                                                </td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 4, 0)}
                                                        className="allcheck">删除</a>
                                                    {/*删除*/}
                                                </td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 5, 0)}
                                                        className="allcheck">导出</a>
                                                    {/*导出*/}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td rowSpan={2}><a href='javascript:void(0)'
                                                    style={{ color: 'inherit' }}
                                                    onClick={this.alllmqx.bind(this, '合同管理')}>合同管理</a></td>
                                                <td>
                                                    <a href='javascript:void(0)'
                                                        onClick={this.allcheckMkqx.bind(this, 0, 1)}
                                                        className="allcheck">租赁合同</a>
                                                </td>
                                                {this.arrcheck(this.state.qxlist, 1)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 102)}
                                                    className="allcheck">测试合同</a></td>
                                                {this.arrcheck(this.state.qxlist, 102)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 2)}
                                                    className="allcheck">房间管理</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 2)}
                                            </tr>
                                            <tr>
                                                <td rowSpan={8}><a href='javascript:void(0)'
                                                    style={{ color: 'inherit' }}
                                                    onClick={this.alllmqx.bind(this, '缴费管理')}>缴费管理</a>
                                                </td>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 301)}
                                                    className="allcheck">房屋租金</a></td>
                                                {this.arrcheck(this.state.qxlist, 301)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 302)}
                                                    className="allcheck">管理服务费</a></td>
                                                {this.arrcheck(this.state.qxlist, 302)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 303)}
                                                    className="allcheck">水费</a></td>
                                                {this.arrcheck(this.state.qxlist, 303)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 304)}
                                                    className="allcheck">电费</a></td>
                                                {this.arrcheck(this.state.qxlist, 304)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 305)}
                                                    className="allcheck">制冷费</a></td>
                                                {this.arrcheck(this.state.qxlist, 305)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 306)}
                                                    className="allcheck">供暖费</a></td>
                                                {this.arrcheck(this.state.qxlist, 306)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 307)}
                                                    className="allcheck">测试费</a></td>
                                                {this.arrcheck(this.state.qxlist, 307)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 308)}
                                                    className="allcheck">服务费</a></td>
                                                {this.arrcheck(this.state.qxlist, 308)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 4)}
                                                    className="allcheck">企业信息</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 4)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 5)}
                                                    className="allcheck">采购管理</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 5)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 12)}
                                                    className="allcheck">在谈项目</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 12)}
                                            </tr>
                                            <tr>
                                                <td rowSpan={2}><a href='javascript:void(0)'
                                                    style={{ color: 'inherit' }}
                                                    onClick={this.alllmqx.bind(this, '载体库')}>载体库</a>
                                                </td>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 131)}
                                                    className="allcheck">厂房</a></td>
                                                {this.arrcheck(this.state.qxlist, 131)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 132)}
                                                    className="allcheck">办公室</a></td>
                                                {this.arrcheck(this.state.qxlist, 132)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 11)}
                                                    className="allcheck">数据统计</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 11)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 6)}
                                                    className="allcheck">账号管理</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 6)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 7)}
                                                    className="allcheck">操作记录</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 7)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 8)}
                                                    className="allcheck">系统设置</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 8)}
                                            </tr>
                                            <tr>
                                                <td><a href='javascript:void(0)'
                                                    onClick={this.allcheckMkqx.bind(this, 0, 9)}
                                                    className="allcheck">数据备份</a></td>
                                                <td></td>
                                                {this.arrcheck(this.state.qxlist, 9)}
                                            </tr>
                                        </table>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="管理园区"
                                    required={true}
                                >
                                    <Checkbox.Group style={{ width: '100%' }}
                                        value={this.state.condition.glyq ? this.state.condition.glyq : null}
                                        onChange={this.onSelChange.bind(this, 'glyq')}>
                                        <Space wrap>
                                            {this.arrcheck2(this.state.glyq_react)}
                                        </Space>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="账号状态"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'status')}
                                        value={this.state.condition.status ? this.state.condition.status : 0}>
                                        {this.arrradio(this.state.status_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </>}
                        <Col className="gutter-row" span={24}>
                            <Form.Item>
                                <Row justify={"center"}>
                                    <Button type='primary' onClick={this.sub.bind(this)}
                                        loading={this.state.loading}>提交</Button>
                                </Row>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </Modal>
        </>)
    }
}

export default Qxedit
